import { render } from "./Dialog-view.vue?vue&type=template&id=f7035892&scoped=true"
import script from "./Dialog-view.vue?vue&type=script&lang=js"
export * from "./Dialog-view.vue?vue&type=script&lang=js"

import "./Dialog-view.vue?vue&type=style&index=0&id=f7035892&scoped=true&lang=css"

import exportComponent from "C:\\Users\\katsuta\\Documents\\AiGlies\\node\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7035892"]])

export default __exports__